import { styled } from "@mui/material";

const HeaderTitle = styled("h3")(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
  fontSize: 16,
  margin: "0 0 20px 0",
}));

export default HeaderTitle;
